module.exports = __webpack_public_path__ + "img/AvatarStef.a30295a3.jpeg";